import WORKOUTS_DOMAIN from './domain'
import WORKOUTS_KEY from './key'

const WORKOUTS_PATH = {
  ALL: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.ALL}`,
  ALL_DATA: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.ALL}.data`,
  BY_PROFILE_ID: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.BY_PROFILE_ID}`,
  CURRENT: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.CURRENT}`,
  STARTED: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.STARTED}`,
  DATA: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.DATA}`,
  LOGGED: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.LOGGED}`,
  LOGGED_DATA: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.LOGGED}.data`,
  NON_LOGGED: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.NON_LOGGED}`,
  NON_LOGGED_DATA: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.NON_LOGGED}.data`,
  PLANNED: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.PLANNED}`,
  PLANNED_DATA: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.PLANNED}.data`,
  NON_LOGGED_AND_PLANNED: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.NON_LOGGED_AND_PLANNED}`,
  NON_LOGGED_AND_PLANNED_DATA: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.NON_LOGGED_AND_PLANNED}.data`,
  RECOMMENDED: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.RECOMMENDED}`,
  RECOMMENDED_DATA: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.RECOMMENDED}.data`,
  DOWNLOADED: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.DOWNLOADED}`,
  SMART: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.SMART}`,
  SMART_VALUE: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.SMART}.value`,
  SUGGESTED: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.SUGGESTED}`,
  PREFERENCES: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.PREFERENCES}`,
  PREFERENCES_SHOULD_UPDATE_WORKOUT_AFTER_LOG: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.PREFERENCES}.shouldUpdateWorkoutAfterLog`
}

export default WORKOUTS_PATH
